import React, { useState, useContext, useMemo, Fragment } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  updateRoomResourceOpenCount,
  getResourceVoteList,
  diamondResource,
} from "../services/rooomService";
import { getUserData } from "../services/userService";
import { StoreContext } from "../Context/StoreContext";
import * as actionTypes from "../constants/actionTypes";
import { useHistory } from "react-router-dom";
import globals from "../globals";
import UserCard from "./UserCard";
import Button from "./Button";
import { newsAppRoutes, profileRoute } from "../routes";
import ResourceVote from "./ResourceVote";
import moment from "moment";
import SpecificChat from "../components/chat/SpecificChat";
import Edit from "./Icons/Edit";
import Trash from "./Icons/Trash";
import Report from "./Icons/Report";
import DeleteModel from "./DeleteModel";
import { getShortenedName, isMobile } from "../utils/utils";
import ProfileModal from "./ProfileModal";
import { NewsPost, DesoApiError } from "../types";
import { SendDiamond } from "./sendDiamond";
import { DiamondIcon } from "./Icons/diamond.icon";
import { useDesoProtocol } from "../hooks/useDesoProtocol";
import Loader from "./Loader";
import { showToast } from "../actions/toastActions";
import { showLoginModal } from "../actions/uiModalActions";
import { Menu, Transition } from "@headlessui/react";
import OptionButton from "./Icons/OptionButton";
import ReportModal from "./Video/VideoControls/ReportModal";
import LinkIcon from "./Icons/LinkIcon";
import ArchiveModal from "./Video/VideoControls/ArchiveModal";
import { archiveType } from "../types/enums";

interface props
  extends Omit<
    NewsPost,
    "location" | "specificChatRoom" | "owner" | "_id" | "live" | "updatedAt"
  > {
  handleDelete: (id: string) => void;
  resourceOwner: any;
  roomId: string;
  roomOwner: string;
  ownerId: string;
  chatCount: number;
  username: string;
  id: string;
  location: string;
  showDiamond: boolean;
}

function ResourceInfoCard({
  companyName,
  tags,
  label,
  location,
  testimonial,
  url,
  count,
  showDiamond = false,
  id,
  description,
  votes,
  createdAt,
  diamondsGivenBySenders,
  username,
  chatCount,
  roomOwner,
  roomId,
  ownerId,
  handleDelete,
  resourceOwner,
  post,
}: props) {
  const locationPath = useLocation();
  const { state, dispatch } = useContext(StoreContext);
  const { auth } = state;
  const [_, setCount] = useState(count);
  const [removeResourceId, setRemoveResourceId] = useState<string | null>(null);
  const [resourceUser, setResourceUser] = useState<any>({});
  const [isOpenSendDiamond, setIsOpenSendDiamond] = useState(false);
  const [isDiamondSendProcessing, setIsDiamondSendProcessing] = useState(false);
  const [isDiamondSending, setIsDiamondSending] = useState(false);
  const ref = React.useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenArchive, setIsOpenArchive] = useState(false);

  const diamondLevelSentByUser = () => {
    if (post) {
      return post.postEntryReaderState?.DiamondLevelBestowed;
    } else {
      const diamondGivenByUser = diamondsGivenBySenders?.find(
        (diamond) => diamond.senderId === auth?.user?._id,
      );
      return diamondGivenByUser?.diamondLevel || 0;
    }
  };
  const checkIfDiamondBestowed = () => {
    if (post) {
      return post.postEntryReaderState?.DiamondLevelBestowed > 0;
    } else if (
      diamondsGivenBySenders &&
      diamondsGivenBySenders.length > 0 &&
      diamondsGivenBySenders.some(
        (diamond) =>
          diamond.senderId === auth?.user?._id && diamond.diamondLevel > 0,
      )
    ) {
      return true;
    }
    return false;
  };

  const isDiamondBestowed = checkIfDiamondBestowed();

  const desoProtocol = useDesoProtocol();

  let isVoted = false;

  useMemo(() => {
    votes.map((vote) => {
      if (vote.owner === auth?.user?._id) {
        isVoted = true;
        return;
      }
    });
  }, [votes]);
  const history = useHistory();
  const openResourceLink = async () => {
    window.open(url, "_blank");
    updateRoomResourceOpenCount(id, auth?.user?.token).then((res) => {
      if (res && res.data && res.data.count) {
        setCount(res.data.count);
      }
    });
  };

  const openVoteUserList = async () => {
    getResourceVoteList(id).then((res) => {
      if (res && res.data) {
        showUserClickModal(res.data);
      }
    });
  };

  const handleSendDiamondAsync = async (DiamondLevel: number) => {
    try {
      setIsDiamondSendProcessing(true);
      if (post) {
        if (!auth?.user?.bitclout_data?.bitclout_publickey) {
          const message = `To access this room you need to login with your deso account`;
          showToast(dispatch, "", message, 2000);
          return;
        }
        await desoProtocol.sendDiamonds({
          SenderPublicKeyBase58Check:
            auth?.user?.bitclout_data?.bitclout_publickey,
          ReceiverPublicKeyBase58Check:
            post.profileEntryResponse.PublicKeyBase58Check,
          DiamondLevel: DiamondLevel,
          DiamondPostHashHex: post.postHashHex,
        });
      } else {
        await diamondResource(
          {
            resourceId: id,
            diamondLevel: DiamondLevel,
            senderId: auth?.user?._id,
          },
          auth?.user?.token,
        );
      }
      const senderId = auth?.user?._id;
      let diamondLevelToUpdate: number = 0;
      if (post) {
        diamondLevelToUpdate = Math.abs(
          DiamondLevel - (post.postEntryReaderState?.DiamondLevelBestowed || 0),
        );
      } else {
        diamondLevelToUpdate = DiamondLevel;
      }

      dispatch({
        type: actionTypes.UPDATE_NEWS_DIAMOND_COUNT,
        payload: {
          resourceId: id,
          diamondLevel: diamondLevelToUpdate,
          senderId,
        },
      });

      setIsDiamondSendProcessing(false);
      setIsOpenSendDiamond(false);
      setIsDiamondSending(false);
      // dispatch(setShowOverlayModal(false));
    } catch (error: any) {
      setIsDiamondSending(false);
      setIsDiamondSendProcessing(false);
      setIsOpenSendDiamond(false);
      const apiError: DesoApiError = error;

      if (apiError.message?.includes("_connectBasicTransferWithExtraSpend")) {
        showToast(
          dispatch,
          "error",
          "Insufficient balance to complete diamond transaction.",
          2000,
        );
      } else {
        showToast(dispatch, "error", apiError.message, 2000);
      }
    }
  };

  const handleSendDiamond = (DiamondLevel: number, diamondAmount: number) => {
    if (!auth?.user) {
      showLoginModal(dispatch);
      return;
    }
    if (post) {
      if (!auth?.user?.bitclout_data?.bitclout_publickey) {
        const message = `To diamond this post you need to login with your deso account`;
        showToast(dispatch, "", message, 2000);
        return;
      }
    }
    if (DiamondLevel > 3) {
      globals.showModal(
        "Diamond",
        <>
          <div className=" justify-center px-3 py-1.5 rounded-2xl  ">
            <div>
              <div className="flex flex-row py-2 items-center gap-4">
                <div>
                  <p className="dark:text-frescoWhite">
                    Are you sure you want to send {diamondAmount} diamonds?
                  </p>
                </div>
              </div>
            </div>
            <div className="pt-3 flex flex-row-reverse">
              <div className="space-x-2">
                <Button
                  size="vibhut-sm"
                  variant="vibhut-secondary"
                  onClick={() => {
                    globals.hideModal();
                  }}
                >
                  Close
                </Button>
                {isDiamondSending ? (
                  <Loader />
                ) : (
                  <Button
                    disabled={isDiamondSending}
                    variant="primary"
                    onClick={() => {
                      globals.hideModal();
                      handleSendDiamondAsync(DiamondLevel);
                    }}
                  >
                    Confirm
                  </Button>
                )}
              </div>
            </div>
          </div>
        </>,
      );
      return;
    }
    handleSendDiamondAsync(DiamondLevel);
  };

  const sendDefaultDiamond = () => {
    if (
      (post &&
        post.postEntryReaderState?.DiamondLevelBestowed &&
        post.postEntryReaderState?.DiamondLevelBestowed >= 1) ||
      diamondsGivenBySenders?.some(
        (diamond) =>
          diamond.senderId === auth?.user?.bitclout_data?.bitclout_publickey &&
          diamond.diamondLevel > 0,
      )
    ) {
      showToast(dispatch, "", "Already Sent Diamonds", 2000);
      return;
    }
    handleSendDiamond(1, 0.01);
  };

  const openUserModal = (user: any) => {
    setResourceUser(user);
  };

  const closeUserModal = () => {
    setResourceUser({});
  };

  const showUserClickModal = (users: any) => {
    globals.showModal(
      `${users.length === 1 ? "User" : "Users"} · ${users.length}    `,
      <>
        <div className="overflow-y-auto custom-scrollbar h-96  pr-2 flex flex-col gap-1 divide-y dark:divide-matteGray">
          {users.map((userData: any, index: number) => (
            <div
              key={index}
              className="flex justify-between items-center -ml-2 py-1"
            >
              <div>
                <UserCard user={getUserData(userData.owner)} size="sm-3" />
              </div>
              <div>
                <Button
                  onClick={() => {
                    globals.hideModal();
                    history.replace(
                      profileRoute.path.replace(
                        ":username",
                        userData?.vibehutUsername || userData.owner._id,
                      ),
                    );
                  }}
                  variant="secondary"
                >
                  View Profile
                </Button>
              </div>
            </div>
          ))}
        </div>
      </>,
    );
  };

  return (
    <div
      className="flex flex-column  pt-[16px] "
      style={{ position: "relative" }}
    >
      <div className="flex items-center flex-col gap-1  ">
        <ResourceVote resourceId={id} isVoted={isVoted} key={id} />
        <div
          className="text-darkGray  dark:border-matteGray text-xs cursor-pointer"
          onClick={openVoteUserList}
        >
          {votes.length}
        </div>
      </div>
      {companyName ? (
        <div className="dark:text-frescoWhite font-ubuntu ml-4">
          <div>
            <p className="flex space-x-1 items-center font-bold">
              {getShortenedName(companyName, 100)}
              {tags.map((tag, index) => {
                return (
                  <span
                    key={index}
                    className="text-darkGray text-sm font-normal"
                  >
                    {" "}
                    &#8226; {tag}
                  </span>
                );
              })}
            </p>
          </div>
          <div className=" space-x-1 items-center">
            <p
              className="text-darkGray text-sm cursor-pointer"
              onClick={openResourceLink}
            >
              {label}
            </p>
            <p className="text-darkGray text-sm inline">&#8226; {location}</p>
          </div>
          <p className="text-xs pt-[8px] custom-third-line-clamp">
            {testimonial || description}
          </p>
        </div>
      ) : (
        <div className="dark:text-frescoWhite font-ubuntu ml-4 w-full  ">
          <div className="flex justify-between ">
            <div className="flex space-x-1 items-center">
              <p
                className="font-bold cursor-pointer "
                onClick={openResourceLink}
              >
                {getShortenedName(label, 100)}
                {tags.map((tag, index) => {
                  return (
                    <span
                      key={index}
                      className="text-darkGray text-sm font-normal"
                    >
                      {" "}
                      &#8226; {tag}
                    </span>
                  );
                })}{" "}
              </p>
            </div>
            {auth?.user && (
              <>
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                  className="ml-1"
                >
                  <Menu as="div" className="relative inline-block text-left">
                    {() => (
                      <>
                        <div>
                          <Menu.Button className="" ref={ref}>
                            <OptionButton />
                          </Menu.Button>
                        </div>
                        <Transition
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items className="absolute right-0 mt-2 w-56 origin-top-right text-darkNight divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-none z-50">
                            {(ownerId === auth?.user?._id ||
                              roomOwner === auth?.user?._id) && (
                              <>
                                <div className="px-1 py-0.5 hover:text-primary">
                                  <Menu.Item>
                                    <Link
                                      to={`/resources/${id}`}
                                      className="group flex rounded-md items-center  justify-between w-full px-2 py-2 text-sm"
                                    >
                                      Edit
                                      <Edit />
                                    </Link>
                                  </Menu.Item>
                                </div>

                                <div className="px-1 py-0.5 ">
                                  <Menu.Item>
                                    <button
                                      onClick={() => setRemoveResourceId(id)}
                                      className="group flex text-cvRed rounded-md items-center justify-between w-full px-2 py-2 text-sm"
                                    >
                                      Delete
                                      <Trash />
                                    </button>
                                  </Menu.Item>
                                </div>
                              </>
                            )}
                            <div className="px-1 py-0.5 ">
                              <Menu.Item>
                                <button
                                  onClick={() => setIsOpen(true)}
                                  className="group flex rounded-md items-center justify-between w-full px-2 py-2 text-sm hover:text-primary"
                                >
                                  Report
                                  <Report color="#000000" stroke />
                                </button>
                              </Menu.Item>
                            </div>
                            {locationPath.pathname === newsAppRoutes.path &&
                              auth?.user?.role === "admin" && (
                                <div className="px-1 py-0.5 ">
                                  <Menu.Item>
                                    <button
                                      onClick={() => setIsOpenArchive(true)}
                                      className="group flex  text-cvRed rounded-md items-center justify-between w-full px-2 py-2 text-sm "
                                    >
                                      Archive
                                      <Report color="#000000" stroke />
                                    </button>
                                  </Menu.Item>
                                </div>
                              )}
                          </Menu.Items>
                        </Transition>
                      </>
                    )}
                  </Menu>
                </div>
                <React.Fragment>
                  <ReportModal
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    peerUserId={ownerId}
                    reportType="news"
                    callId={id}
                  />
                </React.Fragment>
                <React.Fragment>
                  <ArchiveModal
                    isOpen={isOpenArchive}
                    setIsOpen={setIsOpenArchive}
                    type={archiveType.news}
                    id={id}
                  />
                </React.Fragment>
              </>
            )}
          </div>

          <p className="text-xs pt-[8px] whitespace-pre-wrap break-words text-wrap custom-third-line-clamp">
            {testimonial || description}
          </p>
          <div className="flex  gap-2 items-center">
            <p className="text-xs font-normal text-darkGray pt-1 block">
              <span
                className="font-bold cursor-pointer"
                onClick={() => {
                  resourceOwner && openUserModal(resourceOwner);
                }}
              >
                {username}
              </span>{" "}
              added {moment(createdAt).fromNow()}
            </p>
            {auth?.user?.token && (
              <>
                <div>
                  <SpecificChat
                    chatItem={{
                      name: label,
                      _id: id,
                      chatCount,
                      owner: roomOwner,
                    }}
                    type="resource"
                    roomId={roomId as any}
                  />
                </div>
              </>
            )}
            {showDiamond && (
              <div className="relative flex items-center pt-0.5">
                {isOpenSendDiamond && !isMobile() && (
                  <SendDiamond
                    diamondLevel={diamondLevelSentByUser()}
                    setIsOpenSendDiamond={setIsOpenSendDiamond}
                    handleSendDiamond={handleSendDiamond}
                    moveSectionToBottom
                  />
                )}
                <span
                  className="cursor-pointer flex  items-center dark:text-frescoWhite  hover:text-primaryHover"
                  onClick={(e) => {
                    e.stopPropagation();
                    sendDefaultDiamond();
                  }}
                  onMouseEnter={() => setIsOpenSendDiamond(true)}
                >
                  {" "}
                  {isDiamondSendProcessing ? (
                    <span className="w-full h-full flex justify-center items-center">
                      <Loader ratio="h-5 w-5" />
                    </span>
                  ) : (
                    <span className="flex gap-1 items-center">
                      <DiamondIcon
                        width="18"
                        height="18"
                        fill={isDiamondBestowed ? "#716DFF" : "currentColor"}
                        stroke={isDiamondBestowed ? "#716DFF" : "currentColor"}
                      />
                      <span className="text-sm text-darkGray">
                        {post
                          ? post?.diamondCount || ""
                          : diamondsGivenBySenders &&
                            diamondsGivenBySenders?.length > 0 &&
                            diamondsGivenBySenders.length}
                      </span>
                    </span>
                  )}
                </span>
              </div>
            )}
            {post?.postHashHex && (
              <div>
                <Link title="Deso" to={`/feed/${post.postHashHex}`}>
                  <LinkIcon />
                </Link>
              </div>
            )}
          </div>
        </div>
      )}
      <ProfileModal
        copyText={false}
        isOpen={resourceUser._id ? true : false}
        setIsOpen={(open: boolean) => !open && closeUserModal()}
        user={resourceUser}
      />

      <DeleteModel
        handleDelete={() => handleDelete(id)}
        title={label}
        isOpen={removeResourceId === id}
        setIsOpen={() => setRemoveResourceId(null)}
        text="Are you sure to delete this resource?"
        btnvalue="Delete"
      />
    </div>
  );
}

export default ResourceInfoCard;
